/**
 * config
 *
 */

function getLocalCodeByShop(shopId: number): string {
  const shopLocalCodes: { [Key: number]: string } = {
    10281: 'befr',
    10701: 'benl',
    10831: 'benl',
  }
  return shopLocalCodes[shopId] !== undefined ? shopLocalCodes[shopId] : ''
}

/**
 * List of domains by countries
 *
 * @param country
 * @param withLocation
 * @param shopId
 */
export function domainByCountry(
  country: string,
  withLocation: boolean = false,
  shopId: number = 0
): string {
  country = country.toLowerCase()

  if (getLocalCodeByShop(shopId) !== '') {
    country = getLocalCodeByShop(shopId)
  }

  const domains: { [key: string]: string } = {
    at: 'https://www.acredo-trauringe.at',
    // au: 'https://www.acredo.com.au',
    be: 'https://www.acredo.be',
    befr: 'https://www.acredo.be',
    benl: 'https://www.acredo-trouwringen.be',
    fr: 'https://www.acredo.fr',
    ch: 'https://www.acredo-trauringe.ch',
    /* cn: 'http://www.acredo.cn', */
    cz: 'https://www.acredoprsteny.cz',
    de: 'https://www.acredo-trauringe.de',
    dk: 'https://www.acredo.dk',
    ee: 'https://www.acredo-abielusormus.ee',
    es: 'https://www.acredo-alianzas.es',
    hk: 'https://www.acredo.com.hk',
    is: 'https://www.acredo.is',
    /* lt: 'http://www.acredo-vestuviniaiziedai.lt', */
    jp: 'https://www.acredo.jp',
    kr: 'https://www.acredo.kr',
    nl: 'https://www.acredo-trouwringen.nl',
    no: 'https://www.acredo-norway.com',
    sg: 'https://www.acredo.com.sg/en',
    tw: 'https://www.acredo.com.tw',
    us: 'https://www.acredo-bridals.com',
  }

  const locationUrl: { [key: string]: string } = {
    at: '/standorte/',
    be: '/boutiques/',
    befr: '/boutiques/',
    benl: '/locatie/',
    fr: '/boutiques/',
    ch: '/standorte/',
    cn: '/location/',
    cz: '/location/',
    de: '/standorte/',
    dk: '/location/',
    ee: '/location/',
    es: '/location/',
    hk: '/location/',
    is: '/location/',
    lt: '/',
    jp: '/location/',
    kr: '/location/',
    nl: '/locatie/',
    no: '/location/',
    tw: '/location/',
    sg: '/location/',
    us: '/location/',
  }

  if (domains[country]) {
    return domains[country] + (withLocation ? locationUrl[country] : '')
  } else {
    return ''
  }
}

export function leaveShopOnCurrentDomain(
  country: string,
  shopId: number
): boolean {
  const currentCountryCode = (
    process.env.NUXT_ENV_DEFAULT_CODE || 'de'
  ).toLowerCase()

  return (
    currentCountryCode !== country &&
    ((currentCountryCode !== getLocalCodeByShop(shopId) &&
      getLocalCodeByShop(shopId) !== '') ||
      getLocalCodeByShop(shopId) === '')
  )
}
